import { render, staticRenderFns } from "./OperationCustomer.vue?vue&type=template&id=596ba4cf&scoped=true"
import script from "./OperationCustomer.vue?vue&type=script&lang=ts"
export * from "./OperationCustomer.vue?vue&type=script&lang=ts"
import style0 from "./OperationCustomer.vue?vue&type=style&index=0&id=596ba4cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ba4cf",
  null
  
)

export default component.exports